/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { CreateTuyaPairingSessionPathParameters } from 'api/actions/create-tuya-pairing-session/create-tuya-pairing-session-path-parameters';
import { CreateTuyaPairingSessionResponse } from 'api/actions/create-tuya-pairing-session/create-tuya-pairing-session-response';

type CreateTuyaPairingSessionQueryParameters = Record<string, any>;

/**
 * The path of the CreateTuyaPairingSession action.
 */
export const createTuyaPairingSessionActionPath = new SweetPath<keyof CreateTuyaPairingSessionPathParameters>(
  '/tuya-devices/{gatewayTuyaDeviceId}/pairing-sessions',
  { path: '{param}' }
);

/**
 * Creates a contextualized CreateTuyaPairingSession actions.
 */
export default function createCreateTuyaPairingSessionAction(axios: AxiosInstance) {
  return function createTuyaPairingSessionAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: CreateTuyaPairingSessionPathParameters;
    query?: CreateTuyaPairingSessionQueryParameters;
  }) {
    const path = createTuyaPairingSessionActionPath.insert(parameters);

    return axios.post<CreateTuyaPairingSessionResponse, CreateTuyaPairingSessionResponse>(path, {
      params: query,
      headers,
    });
  };
}
